import Table from "components/shared/Table/Table";
import PaginationBar from "components/shared/PaginationBar/PaginationBar";
import { TableWrapper, PaginationBarContainer } from "./styles.tableWithFilters";

/** Filters card (slot) + table + pagination, visually joined into one card. */
export default function TableWithFilters({
  filters,
  columns,
  data,
  getRowId,
  isLoading,
  emptyMessage,
  page,
  hasNextPage,
  onPageChange,
  onRowClick,
}) {
  return (
    <>
      {filters}
      <TableWrapper>
        <Table
          columns={columns}
          data={data}
          getRowId={getRowId}
          isLoading={isLoading}
          emptyMessage={emptyMessage}
          onRowClick={onRowClick}
        />
      </TableWrapper>
      <PaginationBarContainer>
        <PaginationBar page={page} hasNextPage={hasNextPage} onPageChange={onPageChange} />
      </PaginationBarContainer>
    </>
  );
}
